export default {
  key: {
    '0': 'jan',
    '1': 'feb',
    '2': 'mar',
    '3': 'apr',
    '4': 'may',
    '5': 'jun',
    '6': 'jul',
    '7': 'aug',
    '8': 'sep',
    '9': 'oct',
    '10': 'nov',
    '11': 'dec',
  },
  long: {
    jan: "January",
    feb: "February",
    mar: "March",
    apr: 'April',
    may: 'May',
    jun: 'June',
    jul: 'July',
    aug: 'August',
    sep: 'September',
    oct: 'October',
    nov: 'November',
    dec: 'December',
  },
  short: {
    jan: "Jan",
    feb: "Feb",
    mar: "Mar",
    apr: 'Apr',
    may: 'May',
    jun: 'June',
    jul: 'July',
    aug: 'Aug',
    sep: 'Sept',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dec',
  }
}
